/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { traitSaleContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import { BigNumber } from "ethers";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";
import useSnackbarRpcSuccess from "hooks/useSnackbarRpcSuccess";

export type HoneyPurchaseData = {
  amountToSpendFromWallet: BigNumber;
  honeyJars: number[];
  amountToSpendFromHoneyJars: BigNumber[];
  traitTokenIds: number[];
  amountPerTrait: number[];
};

const usePurchaseTraitsUsingHoney = (
  purchaseData?: HoneyPurchaseData,
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, purchase] =
    useContractWrite(
      {
        addressOrName: traitSaleContract.address,
        contractInterface: traitSaleContract.interface,
      },
      "purchaseTraits",
      {
        args: purchaseData,
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({ confirmations: 1, wait: data?.wait });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);
  useSnackbarRpcSuccess(waitData);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [purchase, isLoading || isWaiting];
};

export default usePurchaseTraitsUsingHoney;
